<template>
    <div class="pk">
        <div class="pk-top" @click="close()"><i class="el-icon-arrow-down"></i></div>
        <div class="pk-content xw-scrollbar">
            <transition name="el-zoom-in-top">
            <div class="pk-c-1" v-if="!status">
                <img src="../../content/images/pk/pk.png" alt="pk">
                <p class="title">知己知彼，方能百战百胜</p>
                <div class="input-box">
                    <el-select class="input-select" v-model="industryId" placeholder="行业选择">
                        <el-option
                            v-for="item in industries"
                            :key="item._id"
                            :label="item.name"
                            :value="item._id">
                        </el-option>
                    </el-select>
                    <input type="text" class="input-text" placeholder="请输入竞争对手的网址"
                           v-model="url"
                           @keyup="urlChange"
                           @mousedown="urlChange"
                           @mouseout="urlChange"
                           @keyup.enter="beforeStart()">
                    <el-button type="primary" class="input-btn" @click="beforeStart()" v-bd-track-event="['营销力诊断', '点击开始对比']">开始对比</el-button>
                </div>
            </div>
            </transition>
            <transition name="el-zoom-in-bottom">
            <pk-detail v-if="!!status"
                       :from-url="fromUrl"
                       :url="url"
                       :progress="progress"
                       :list="list"
                       :finished="finished"></pk-detail>
            </transition>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import Validate from '../../store/validate'
import pkDetail from './PKDetail'
import _ from 'lodash'
export default {
    components: {
        pkDetail
    },
    props: ['visible', 'from-url'],
    data() {
        return {
            status: 0,
            finished: false,
            industryId: '',
            url: '',
            token: '',
            pkLogId: '',
            progress: {},
            list: []
        }
    },
    computed: {
        ...mapState('company', ['industries']),
        ...mapState('check', ['pkVisible'])
    },
    created() {
        this.getIndustries();
    },
    methods: {
        ...mapMutations('check', ['setPKVisible']),
        ...mapActions('company', ['getIndustries']),
        ...mapActions('check', ['startPK', 'getProgressPK', 'getListPK', 'cancelPK']),
        //检测前的校验
        beforeStart () {
            this.url = this.url || '';
            if (!this.industryId) {
                this.$message.error('请选择行业');
                return;
            }
            if (!this.url) {
                this.$message.error('请输入网址');
                return;
            }
            if (!Validate.validateUrl(this.url)) {
                this.$message.error('请输入正确的网址');
                return;
            }
            if (this.url.split('.').length === 2 && !/^www\./i.test(this.url)) {
                this.url = 'www.' + this.url;
            }
            if (this.url.toLowerCase() === this.fromUrl.toLowerCase()) {
                this.$message.error('不能自己PK自己哦');
                return;
            }
            this.checkStart();
        },
        // 启动检测
        checkStart () {
            let url = this.url.toLowerCase();
            url = Validate.getDomain(url);
            this.startPK({url, industryId: this.industryId}).then(res => {
                this.finished = false;
                this.status = 1;
                this.token = res.token;
                this.pkLogId = res.pkLogId;
                if (res.isFinish) {
                    this.getList();
                } else {
                    this.getProgress();
                }
            }, err => {
                this.errorHandle(err);
            })
        },
        getProgress () {
            if (this.finished) return;
            this.getProgressPK(this.token).then(res => {
                if (res.isError) {
                    this.$alert('诊断异常，请稍后重试', '提示');
                } else if (res.progress && res.progress === 100) {
                    this.getList();
                } else {
                    this.setData(res);
                    setTimeout(() => {
                        this.getProgress();
                    }, 3000);
                }
            })
        },
        getList () {
            this.finished = true;
            this.getListPK(this.token).then(res => {
                this.setData(res);
            })
        },
        setData (res) {
            this.list = res.data;
            this.progress = _.omit(res, ['data']);
        },
        // 错误处理
        errorHandle (err) {
            let alertOptions = {
                customClass: 'sys-hint',
                confirmButtonText: '知道了'
            };
            if (!err || !err.errorCode) {
                this.$alert(err || '启动失败', '提示', alertOptions)
            }
            switch(err.errorCode) {
                case 1: case 2:
                    this.$alert(err.errorMsg, '提示', alertOptions);
                    break;
            }
        },
        //url格式化
        urlChange () {
            if (Validate.validateUrl(this.url)) {
                let url = (this.url || '')
                    .replace(/\s/g, '')
                    .match(/[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?/);
                this.url = (url || [''])[0];
            }
        },
        beforeClose() {
            return !this.finished && this.status ? new Promise((resolve, reject) => {
                this.$msgbox({
                    title: '提示',
                    message: '检测正在进行中，是否取消？',
                    showCancelButton: true,
                    beforeClose: (action, instance, done) => {
                        if (action === 'confirm') {
                            instance.confirmButtonLoading = true;
                            instance.confirmButtonText = '正在取消...';
                            this.cancelPK(this.token).then(() => {
                                this.$message('已取消本次PK');
                                done();
                                instance.confirmButtonLoading = false;
                            }, error => {
                                this.errorFun(error);
                            });
                        } else {
                            done();
                        }
                    }
                }).then(action => {
                    if (action === 'confirm') {
                        resolve();
                    } else {
                        reject();
                    }
                }, reject)
            }) : Promise.resolve();
        },
        close() {
            this.beforeClose().then(() => {
                this.finished = true;
                this.setPKVisible(false);
            }, () => {})
        }
    }
}
</script>

<style lang="scss" scoped>
    $height: 70px;
    .pk {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 100;
        width: 100%;
        height: 100%;
        padding-top: $height;
    }
    .pk-top {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: $height;
        font-size: 40px;
        color: #fff;
        line-height: 70px;
        text-align: right;
        padding: 0 5%;
        background-color: rgba(0, 0, 0, 0.8);
        cursor: pointer;
        &:hover {
            background-color: rgba(0, 0, 0, 0.6);
        }
    }
    .pk-content {
        height: 100%;
        background-color: #f1f1f1;
        text-align: center;
        overflow-y: auto;
    }
    .pk-c-1 {
        height: 100%;
        padding-top: 6.7rem;
        img {
            width: 7rem;
        }
        .title {
            font-size: 3rem;
            margin: 4rem 0 3.2rem;
        }
    }
    .input-box {
        $leftWidth: 180px;
        $rightWidth: 200px;
        position: relative;
        width: 1000px;
        max-width: 90%;
        height: 4rem;
        margin: 0 auto;
        padding: 0 $rightWidth 0 $leftWidth;
        .input-select, .input-btn {
            position: absolute;
            top: 0;
        }
        .input-select {
            left: 0;
            width: $leftWidth;
            border-right: 1px solid #dedede;
        }
        .input-text {
            width: 100%;
            height: 100%;
            font-size: 1rem;
            text-indent: 2rem;
            border: 0;
            background-color: #fff;
        }
        .input-btn {
            right: 0;
            width: $rightWidth;
            height: 100%;
            font-size: 1.3rem;
            border-radius: 0 4px 4px 0;
        }
    }
</style>
<style lang="scss">
    .pk {
        .input-box .el-input__inner {
            font-size: 1rem;
            height: 4rem;
            line-height: 4rem;
            padding: 0 15px 0 50px;
            border: 0;
            &::-webkit-input-placeholder {
                color: #1f1f20;
            }
        }
        .input-box .el-input__suffix {
            right: auto;
            left: 15px;
        }
        .input-box .el-select__caret {
            font-size: 18px;
            color: #1f1f20;
        }
    }
</style>



// WEBPACK FOOTER //
// app/view/detail/PK.vue